import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader',
  standalone: true,
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  @Input() Width = 57;

  constructor() { }

  ngOnInit() { }
}
